import { render, staticRenderFns } from "./PointsList.vue?vue&type=template&id=31fb485a&"
import script from "./PointsList.vue?vue&type=script&lang=js&"
export * from "./PointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports